// extracted by mini-css-extract-plugin
export default {"wrapperClass":"rZf2AbGKDN3xcX2bC4Eh"};